export default "__VITE_ASSET__CgKHZwpJ__"